<form #form="ngForm" name="lastpass-disable-search" autocomplete="off" _lpchecked="1">
    <ng-container *ngIf="applicant">
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.firstName' | appTranslate }}</mat-label>
                <input
                    type="text"
                    matInput
                    name="firstName"
                    [(ngModel)]="applicant.firstName"
                    required
                    #firstName="ngModel"
                />
                <mat-error *ngIf="firstName.invalid">{{ firstName.errors | formErrors }} </mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.lastName' | appTranslate }}</mat-label>
                <input
                    type="text"
                    matInput
                    name="lastName"
                    [(ngModel)]="applicant.lastName"
                    required
                    #lastName="ngModel"
                />
                <mat-error *ngIf="lastName.invalid">{{ lastName.errors | formErrors }} </mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.email' | appTranslate }}</mat-label>
                <input
                    data-lpignore="true"
                    type="email"
                    email
                    matInput
                    name="email"
                    [(ngModel)]="applicant.email"
                    required
                    #email="ngModel"
                    autocomplete="off"
                />
                <mat-error *ngIf="email.invalid">{{ email.errors | formErrors }} </mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.phone' | appTranslate }}</mat-label>
                <input type="text" matInput name="phone" [(ngModel)]="applicant.phone" #phone="ngModel" />
                <mat-error *ngIf="phone.invalid">{{ phone.errors | formErrors }} </mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.country' | appTranslate }}</mat-label>
                <ui-country-autocomplete
                    name="country"
                    #country="ngModel"
                    [(ngModel)]="applicant.country"
                ></ui-country-autocomplete>
                <mat-error *ngIf="country.invalid">{{ country.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.components.update-basic-info.postalCode' | appTranslate }}</mat-label>
                <input
                    type="text"
                    matInput
                    name="postalCode"
                    #postalCode="ngModel"
                    [(ngModel)]="applicant.postalCode"
                />
                <mat-error *ngIf="postalCode.invalid">{{ postalCode.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
